export const CAROUSEL_ACTIVE = 'active';
export const CAROUSEL_CLASS_NAME = 'banner-carousel';
export const CAROUSEL_DATA = 'bs.carousel';
export const CAROUSEL_EVENT = `slide.${CAROUSEL_DATA}`;
export const INTERVAL_DATA = 'data-interval';
